import React, {useMemo} from "react";
import {css} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {ClipPhoneButton} from "../../../atoms/ClipPhoneButton";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {gtmRotatingPhoneNumbersCall, gtmRotatingPhoneNumbersReveal} from "../../../tracking/google_tag_manager/gtm_rotating_phone_numbers";

interface IProps {
    isAutoresponderEnabled: boolean;
    isDataFetched: boolean;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
    useHotlineNumber?: boolean;
}

export const ApplicationFormBoxPhoneNumber = (props: IProps) => {
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );

    if (!props.isDataFetched) {
        return <Loader size="md" className={loaderStyle} />;
    }

    return !props.isAutoresponderEnabled ? (
        <>
            <Text align="center" className={separatorTextStyle} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                lub zadzwoń
            </Text>

            <ClipPhoneButton
                fallbackNumber={fallbackPhoneNumber}
                onClickPhoneNumber={() => {
                    gtmRotatingPhoneNumbersCall();
                }}
                onShowPhoneNumber={() => {
                    gtmRotatingPhoneNumbersReveal();
                }}
                propertyId={props.propertyId}
                className={phoneButtonStyle}
                customPhoneButton={(onClick, phoneNumber) => (
                    <div className={columnCenterStyle}>
                        <div className={phoneSectionStyle}>
                            <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                            <Link className={linkStyle} href={`tel:+${phoneNumber}`} onClick={onClick}>
                                <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                )}
                useHotlineNumber={props.useHotlineNumber}
            />
        </>
    ) : null;
};

const separatorTextStyle = css({
    marginTop: 2,
    marginBottom: 1
});

const columnCenterStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const phoneSectionStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 2
});

const linkStyle = css({
    marginLeft: 2,
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});

const phoneButtonStyle = css({
    width: "100%",
    textAlign: "center"
});

const loaderStyle = css({
    w: "100%",
    h: "76px",
    alignItems: "center",
    marginTop: 2,
    opacity: 0.5
});
import React, {useMemo} from "react";
import {css} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {ClipPhoneButton} from "../../../atoms/ClipPhoneButton";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {gtmRotatingPhoneNumbersCall, gtmRotatingPhoneNumbersReveal} from "../../../tracking/google_tag_manager/gtm_rotating_phone_numbers";

interface IProps {
    isAutoresponderEnabled: boolean;
    isDataFetched: boolean;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
    useHotlineNumber?: boolean;
}

export const ApplicationFormBoxPhoneNumber = (props: IProps) => {
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );

    if (!props.isDataFetched) {
        return <Loader size="md" className={loaderStyle} />;
    }

    return !props.isAutoresponderEnabled ? (
        <>
            <Text align="center" className={separatorTextStyle} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                lub zadzwoń
            </Text>

            <ClipPhoneButton
                fallbackNumber={fallbackPhoneNumber}
                onClickPhoneNumber={() => {
                    gtmRotatingPhoneNumbersCall();
                }}
                onShowPhoneNumber={() => {
                    gtmRotatingPhoneNumbersReveal();
                }}
                propertyId={props.propertyId}
                className={phoneButtonStyle}
                customPhoneButton={(onClick, phoneNumber) => (
                    <div className={columnCenterStyle}>
                        <div className={phoneSectionStyle}>
                            <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                            <Link className={linkStyle} href={`tel:+${phoneNumber}`} onClick={onClick}>
                                <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                )}
                useHotlineNumber={props.useHotlineNumber}
            />
        </>
    ) : null;
};

const separatorTextStyle = css({
    marginTop: 2,
    marginBottom: 1
});

const columnCenterStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const phoneSectionStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 2
});

const linkStyle = css({
    marginLeft: 2,
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});

const phoneButtonStyle = css({
    width: "100%",
    textAlign: "center"
});

const loaderStyle = css({
    w: "100%",
    h: "76px",
    alignItems: "center",
    marginTop: 2,
    opacity: 0.5
});
